import { Star } from "lucide-react";
import { Card } from "@/components/ui/card";
import googleLogo from "@/assets/google-logo.png";
import googleG from "@/assets/google-g.png";

const reviews = [
  {
    name: "Wilhelm Brauer",
    when: "vor 2 Monaten",
    rating: 5,
    text: "Malerfachbetrieb Stein hat unsere Fassade gestrichen. Vom Start bis zum Ende waren wir sehr zufrieden. Alle Flächen wurden sorgfältig abgeklebt und abgedeckt, nach Abschluss der Arbeiten wurde alles sauber und ordentlich entfernt. Die Arbeiten wurden fachgerecht und zuverlässig ausgeführt. Auch die Mitarbeiter waren durchweg höflich und freundlich. Wir können den Betrieb uneingeschränkt weiterempfehlen.",
  },
  {
    name: "D. Meier",
    when: "vor 1 Monat",
    rating: 5,
    text: "Auch ohne dass ein Auftrag zustande kam, möchten wir uns für die gute Beratung bedanken. Herr Stein war sehr kompetent, ehrlich und hat sich die Zeit genommen, unsere Fragen zu beantworten. Ein seriöser und professioneller Malerbetrieb.",
  },
  {
    name: "Andreas Kahles",
    when: "vor 1 Monat",
    rating: 5,
    text: "Wir haben mit Herrn Stein ein größeres Projekt (Fassadendämmung, Balkonbeschichtung etc. im 7-Familienhaus) erfolgreich fertiggestellt. Wir können den Betrieb ohne Einschränkung weiterempfehlen! Profis – zuverlässig, sauber, schnell und sehr freundlich. Nochmals herzlichen Dank.",
  },
  {
    name: "V. H.",
    when: "vor 2 Monaten",
    rating: 5,
    text: "Sehr seriöser Malerfachbetrieb. Man wird ausführlich und verständlich über alle Möglichkeiten informiert und fühlt sich als Kunde ernst genommen. Sämtliche Absprachen wurden zuverlässig eingehalten. Die Arbeiten wurden schnell, sauber und sorgfältig ausgeführt. Absolut empfehlenswert!",
  },
  {
    name: "Helene B.",
    when: "vor 4 Monaten",
    rating: 5,
    text: "Wir haben den Maler über den Bauträger kennengelernt und sind positiv überrascht worden. Arbeiten wurden ordentlich und nach direkter Rücksprache schnell umgesetzt. Bei wetterbedingten Verzögerungen wurden wir sofort informiert. Fragen werden angehört und fundiert beantwortet. mfb Stein setzt abgesprochene Aufgaben fach- und zeitgerecht um.",
  },
  {
    name: "Artur Zelmer",
    when: "vor 8 Monaten",
    rating: 5,
    text: "Wir haben schon mehrmals Arbeiten vom Malerfachbetrieb Stein erledigen lassen und waren jedes Mal sehr zufrieden. Herr Stein ist zuverlässig, pünktlich und arbeitet sauber. Besonders schön: der Kontakt war immer freundlich und angenehm – auch jetzt noch nimmt er sich Zeit für Fragen. Kann ich nur weiterempfehlen.",
  },
  {
    name: "Elena S.",
    when: "vor 11 Monaten",
    rating: 5,
    text: "Herr Stein hat bei uns die Wärmedämmung gemacht und wir sind wirklich begeistert. Vom ersten Gespräch bis zur letzten Pinselbewegung lief alles reibungslos – zuverlässig, freundlich und alles verständlich erklärt. Auch bei der Farbgestaltung haben wir dank seiner Geduld und vielen Musterflächen die perfekte Lösung gefunden. Ein echtes Handwerksunternehmen mit Herz!",
  },
  {
    name: "Ripcraft Blackbone",
    when: "vor 1 Jahr",
    rating: 5,
    text: "Firma Stein kann man nur empfehlen – saubere Arbeit, freundliche, professionelle Handwerker.",
  },
];

export const GoogleReviews = () => {
  const track = [...reviews, ...reviews];
  return (
    <section className="py-16 md:py-24 bg-muted/20">
      <div className="container mx-auto mb-12">
        <div className="text-center">
          <div className="inline-flex items-center gap-3 mb-4">
            <img src={googleLogo} alt="Google" className="h-7" width="92" height="30" loading="lazy" />
            <span className="text-xl font-bold">Bewertungen</span>
          </div>

          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="text-4xl font-bold">4.7</span>
            <div>
              <div className="flex gap-0.5">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-yellow-500 text-yellow-500" />
                ))}
              </div>
              <p className="text-xs text-muted-foreground mt-1">
                Basierend auf 25 Bewertungen
              </p>
            </div>
          </div>

          <h2 className="font-caslon text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
            Das sagen unsere Kunden aus Herford
          </h2>
          <div className="w-16 h-px bg-foreground/30 mx-auto" />
        </div>
      </div>

      {/* Marquee */}
      <div className="relative overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)]">
        <div className="marquee-track flex gap-6">
          {track.map((review, index) => (
            <Card
              key={index}
              className="p-6 bg-background shrink-0 w-[340px] md:w-[380px] flex flex-col"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-lg bg-foreground/10 flex items-center justify-center text-foreground font-bold text-sm">
                  {review.name.charAt(0)}
                </div>
                <div>
                  <p className="font-semibold text-sm leading-tight">{review.name}</p>
                  <p className="text-[11px] text-muted-foreground">{review.when}</p>
                </div>
              </div>

              <div className="flex gap-0.5 mb-3">
                {[...Array(review.rating)].map((_, i) => (
                  <Star key={i} className="w-3.5 h-3.5 fill-yellow-500 text-yellow-500" />
                ))}
              </div>

              <p className="text-sm text-muted-foreground leading-relaxed line-clamp-6">
                {review.text}
              </p>

              <div className="mt-4 pt-3 border-t border-border/50">
                <div className="flex items-center gap-2">
                  <img src={googleG} alt="Google" className="w-3.5 h-3.5" width="16" height="16" loading="lazy" />
                  <span className="text-[11px] text-muted-foreground">Google Bewertung</span>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
